"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Menubar = void 0;
const react_1 = __importDefault(require("react"));
const react_hotkeys_1 = require("react-hotkeys");
const lodash_1 = require("lodash");
const clsx_1 = __importDefault(require("clsx"));
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const menubar_styles_1 = require("./menubar-styles");
const menu_1 = require("./menu/menu");
const user_btn_1 = require("./user-btn/user-btn");
const menubar_hook_1 = require("./menubar-hook");
const menubar_context_1 = require("./menubar-context");
function Menubar({ logo, logoUrl = '/', title, items: providedItems, hotKeys: providedHotKeys = { keyMap: {}, handlers: {} }, children, userBtnActions, displayLogoutBtn, beforeUserBtn, afterUserBtn, classOverrides, }) {
    const classes = menubar_styles_1.useStyles();
    const { handleLogoClick, items, context } = menubar_hook_1.useMenubar({
        logoUrl,
        items: providedItems,
    });
    const hotKeys = {
        keyMap: { ...providedHotKeys.keyMap },
        handlers: { ...providedHotKeys.handlers },
    };
    gatherHotKeys(hotKeys, items);
    return (react_1.default.createElement(menubar_context_1.MenubarContext.Provider, { value: context },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(react_hotkeys_1.GlobalHotKeys, { keyMap: hotKeys.keyMap, handlers: hotKeys.handlers, allowChanges: true }),
            react_1.default.createElement("div", { className: clsx_1.default(classes.menuBarWrapper, classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.menuBarWrapper) },
                react_1.default.createElement("a", { onClick: handleLogoClick, className: clsx_1.default(classes.iconlink, classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.iconlink) }, logo),
                react_1.default.createElement("div", { className: clsx_1.default(classes.menuBarInnerWrapper, classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.menuBarInnerWrapper) },
                    react_1.default.createElement(Grid_1.default, { container: true, className: clsx_1.default(classes.menuContainer, classOverrides === null || classOverrides === void 0 ? void 0 : classOverrides.menuContainer) },
                        react_1.default.createElement(Grid_1.default, null, title),
                        react_1.default.createElement(Grid_1.default, null,
                            beforeUserBtn,
                            react_1.default.createElement(user_btn_1.UserBtn, { actions: userBtnActions, displayLogoutBtn: displayLogoutBtn, classOverrides: classOverrides }),
                            afterUserBtn)),
                    react_1.default.createElement(menu_1.Menu, { items: items, classOverrides: classOverrides }))),
            children)));
}
exports.Menubar = Menubar;
function preventEventWrapperFactory(callback) {
    return function wrappedCallback(e) {
        e && e.preventDefault();
        callback();
    };
}
function gatherHotKeys(hotKeys, items) {
    items === null || items === void 0 ? void 0 : items.forEach((item) => {
        var _a;
        if (item.keyShortcut !== undefined) {
            hotKeys.keyMap[item.keyShortcut] = item.keyShortcut;
            hotKeys.handlers[item.keyShortcut] = preventEventWrapperFactory((_a = item.onClick) !== null && _a !== void 0 ? _a : lodash_1.noop);
        }
        gatherHotKeys(hotKeys, item.items);
    });
}
//# sourceMappingURL=menubar.js.map